import React, { useContext, useEffect, useState } from 'react';
import {format} from 'date-fns';
import STC from '../../../../../../../../STCLibrary/STCFactory/STCFactory';
import { PassengerAPI } from '../../../../../../../../API/PassengerAPIs/PassengerAPIs';
import "./ViewTourInfo.css"
import { useNavigate, useParams } from 'react-router-dom';
import GlobalPaymentsController from '../../../../../../../../API/GlobalPaymentsAPIs/GlobalPaymentsController';
import LoadingPayment from './LoadingPayment/LoadingPayment';
import PaymentForm from './PaymentForm/PaymentForm';
import NotificationContext from '../../../../../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import { CappedAPIs } from '../../../../../../../../API/CappedAPIs/CappedAPIs';
import { ReportsAPIs } from '../../../../../../../../API/ReportsAPIs/ReportsAPIs';
import { GetMaintenanceContext } from '../../../../../../PageRoutes/PageRoutes';

export default function Info({passenger, tour}){

    const routeParams = useParams();
    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);
    const getMaintenanceCtx = useContext(GetMaintenanceContext);

    const [accDetails, setAccDetails] = useState();
    const [firstDeposit, setFirstDeposit] = useState(tour.displayDeposits.filter((deposit) => deposit.note === 'Deposit First Instalment')[0]);
    const [totalPaid, setTotalPaid] = useState()
    const [outstanding, setOutstanding] = useState()
    const [loading, setLoading] = useState(true);
    const [makingPayment, setMakingPayment] = useState(false);
    const [sending, setSending] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [failedToLoad, setFailedToLoad] = useState(false);
    const [showDeposits, setShowDeposits] = useState(false);
    const [latestPayment, setLatestPayment] = useState(null);

    const [paymentAmount, setPaymentAmount] = useState("");

    const handleMakePaymentButton = () => {
        getMaintenanceCtx();
        if(!makingPayment){
            checkTourCapping();
        }
        else{
            setMakingPayment(!makingPayment);
            setFailedToLoad(false);
            setErrorMsg('');
        }

    }

    const getBalances = () => {
        let paid = 0;
        PassengerAPI.GetPaymentHistory(passenger.id)
        .then((response) => {
            const payments = response.data.filter((payment) => payment.bookingId === tour.bookingId).sort((a, b) => a.createdDate > b.createdDate);
            payments.map((payment) => {
                paid = paid + payment.amount
            })
            console.log(payments);
            if(payments.length > 0){
                setLatestPayment(payments[payments.length -1])
            }
            setTotalPaid(paid);
            if(paid < tour.passengerPrice ){
                setOutstanding(tour.passengerPrice - paid);
                if( (paid < firstDeposit?.amount ?? 0) && firstDeposit.shown){
                    setPaymentAmount(firstDeposit.amount - paid)
                }
                else {
                    setPaymentAmount(tour.passengerPrice - paid);
                }
            }
            else{
                setOutstanding(0)
            }

            
            
           
            setLoading(false);
        })
        .catch((err) => {
            console.log(err);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
    }


    const getGlobalReceiptBalances = () => {

        const postJSON = {
            bookingId: tour.bookingId,
            globalPassengerId: "",
            portalPassengerId: passenger.id,
            startDate: "",
            endDate: "",
            currency: "",
            refundReceiptsIncluded: true
        }
        let paid = 0;
        ReportsAPIs.PostGlobalReceiptsFilter(postJSON)
        .then((response) => {
            const payments = [...response.data.globalBookingReceiptList, ...response.data.refundReceiptsList];
            payments.map((payment) => {
                paid = paid + (payment.amountPaid ?? -payment.amountRefunded)
            })
            setTotalPaid(paid);
            if(paid < tour.passengerPrice ){
                setOutstanding(tour.passengerPrice - paid);
                if( (paid < firstDeposit?.amount ?? 0) && firstDeposit.shown){
                    setPaymentAmount(firstDeposit.amount - paid)
                }
                else {
                    setPaymentAmount(tour.passengerPrice - paid);
                }
            }
            else{
                setOutstanding(0)
            }

            
            
           
            setLoading(false);
        })
        .catch((err) => {
            console.log(err);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
    }

    const goToPaymentPage = () => {
        GlobalPaymentsController.GoToPaymentsPage(routeParams.userID, paymentAmount * 100, tour, passenger)
        .then((response) => {
            if(response.status === 200){
                const newURL = response.data.url
                window.location.href = newURL;
            }
            
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            setFailedToLoad(true);
            setErrorMsg('Failed to connect to payment provider. Please try again later')
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setSending(true);
        setFailedToLoad(false);
        setErrorMsg('');
        
        if(paymentAmount > 0){
            goToPaymentPage();
        }
        else{
            setErrorMsg('Please enter a value higher than 0.');
            setFailedToLoad(true);
            setSending(false);
        }
    }

    const checkTourCapping = () => {
        CappedAPIs.GetCappingCheck(tour.bookingId, passenger.id)
        .then((response) => {
            console.log(response);
            if(response.status === 200){
                if(response.data.eligible){
                    setMakingPayment(!makingPayment);
                    setFailedToLoad(false);
                    setErrorMsg('');
                }
                else{
                    setFailedToLoad(true);
                    setErrorMsg('This tour is full. We are unable to add any more passengers at this time. Please contact your tour leader.')
                }
            }
        })
        .catch((err) => {
            console.log(err)
            ApiResponseHandler(err.response, notificationCtx, navigate)
        })
    }

    useEffect(() => {
        getBalances();
        // getGlobalReceiptBalances();
        tour.displayDeposits.map((deposit) => {
            if(deposit.shown){
                setShowDeposits(true);
            }
        })
        setMakingPayment(false);
    }, [tour.bookingId])

    if( new Date() > new Date(tour.dateOfReturn)){
        return(<STC.Alert variant='danger'>This tour has been completed.</STC.Alert>)
    }
    else{
        return(
            <div>
                {sending && <LoadingPayment/>}
                <div className='view-passenger-tour-info-line'>
                    <strong>School:</strong>
                    <div> {tour.schoolName}</div>
                </div>
                <div className='view-passenger-tour-info-line'>
                    <strong>Destination:</strong> 
                    <div>{tour.destinations.map((dest, index) => {
                    if(tour.destinations.length > 1 && index + 1 < tour.destinations.length){
                        return(dest + ', ')
                    }
                    else{
                        return (
                            dest
                        )
                    }
                    })}
                    </div>
                </div>
                <div className='view-passenger-tour-info-line'>
                    <strong>Date of Travel:</strong>
                    <div> {format(new Date(tour.dateOfTravel), 'dd-LLL-yyyy')}</div>
                </div>
                <div className='view-passenger-tour-info-line'>
                    <strong>Date of Return: </strong>
                    <div>{format(new Date(tour.dateOfReturn), 'dd-LLL-yyyy')}</div>
                </div>
                <div className='view-passenger-tour-info-line'>
                    <strong>Booking ID:</strong>
                    <div> {tour.bookingId}</div>
                </div>
                <div className='view-passenger-tour-info-line'>
                        <strong>Base Tour Price: </strong>
                        <div>{tour.currency === 'GBP' ? '£' : '€'}{tour.passengerPrice}</div>
                    </div>
                <div className='tour-finances'>
                    
                    {/* {firstDeposit?.shown && <div className='view-passenger-tour-info-line'>
                        <strong>Deposit: </strong>
                        <div style={totalPaid > firstDeposit.amount? {color: STC.Green} : {color: 'red'}}>{totalPaid > firstDeposit.amount ? 'Paid' : '€'+firstDeposit.amount}</div>
                    </div>} */}
                    {showDeposits &&
                    <STC.Table>
                        <thead>
                            <tr>
                                <th>Payment</th>
                                <th>Due</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                        {tour.displayDeposits.map((deposit) => {
                            if(deposit.shown){
                                return(
                                    <tr key={deposit.id}>
                                        <td>{deposit.note}: </td>
                                        <td>{format(new Date(deposit.collectionDate), 'dd-LLL-yyyy')}</td>
                                        <td>{(tour.currency === 'GBP' ? '£': '€') + deposit.amount}</td>
                                    </tr>
                                )
                            }
                        })}
                        </tbody>
                    </STC.Table>
                    }
                    
                    <div className='view-passenger-tour-info-line'>
                        <strong>Outstanding: </strong>
                        <div className={outstanding > 0 ? "outstanding" : ""}>{loading ? "Calculating..." : (tour.currency === 'GBP' ? '£': '€')+ outstanding } </div>
                    </div>
                    {latestPayment && 
                    <div className='view-passenger-tour-info-line'>
                        <strong>Latest Payment</strong>
                        <div>{format(new Date(latestPayment.createdDate), 'dd/LLL/yyyy')}</div>
                    </div>}
                    <div className="amount-paid-line" >
                        <div>{loading ? "Calculating..." : (totalPaid > tour.passengerPrice ? "Fully Paid": (tour.currency === 'GBP' ? '£': '€')+ totalPaid+" paid of " + (tour.currency === 'GBP' ? '£': '€')+ tour.passengerPrice)}</div>
                    </div>
                </div>
    
                {/* {new Date() > new Date(tour.dateOfReturn) ?
                    <STC.Alert variant='danger'>This tour has been completed.</STC.Alert>
                    : */}
                <div style={{marginTop: "5px"}}>
                    <STC.Alert variant='warning'>Outstanding amount shown is base tour price ONLY and does not include relevant supplements as advised by the Group Leader.</STC.Alert>
                </div>

                <div className='m-2' style={{display: "flex", justifyContent: "center"}}>
                    <STC.Button className={makingPayment ? 'clear' : ''} disabled={sending} onClick={handleMakePaymentButton} size='sm' style={{width: "90%"}}>
                        {makingPayment ? "Cancel payment" :"Make a Payment - " + passenger.firstName + ' ' + passenger.surname + ' B-' + tour.bookingId}
                    </STC.Button>
                </div>
    
                {failedToLoad && <STC.Alert variant='danger'>{errorMsg}</STC.Alert>}
                
                {makingPayment &&
                <div>
                    {totalPaid > 0 ?  
                        <STC.Alert variant='danger'>By paying you acknowledge this is for <strong>{passenger.firstName} {passenger.surname}</strong> on tour B-{tour.bookingId}</STC.Alert>
                    : 
                        <STC.Alert variant='danger'>You are attempting to make a payment to add <strong>{passenger.firstName} {passenger.surname}</strong> to B-{tour.bookingId}</STC.Alert>
                    }
                    <PaymentForm passenger={passenger} paymentAmount={paymentAmount} bookingID={tour.bookingId} tour={tour} latestPayment={latestPayment} date={new Date()}/>
                </div>
                }
                
            </div>
        )
    }
    


}